module.exports = __webpack_public_path__ + "static/media/10.e5d2e2b1.jpg";